
const initialState = {
  comment: '',
  attachedFiles: [],
  focused: false,
};

function commentBox(state = initialState, { type, payload }) {
  switch (type) {
    case 'HANDLE_CONTRACTING_COMMENT_INPUT':
      return { ...state, comment: payload };
    case 'HANDLE_CONTRACTING_COMMENT_FILE_INPUT':
      return { ...state, attachedFiles: payload };
    case 'SET_CONTRACTING_COMMENT_FOCUS':
      return { ...state, focused: payload };
    case 'CANCEL_CONTRACTING_COMMENT':
    case 'SUBMIT_CONTRACTING_COMMENT_STARTED':
      return initialState;
    default:
      return state;
  }
}

export default commentBox;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/comment-reducer.js